import { colors } from "../../Styles";

export function Cam({rotate = 0, size = "25px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg style={{transform: `rotate(${rotate}deg)`}} height={size} width={size} stroke={fillColor} version="1.1" viewBox="0 0 100 100" >
        <path d="M 25 20 
          h 50 
          a 10 10 0 0 1 10 10 
          v 40 
          a 10 10 0 0 1 -10 10 
          h -50 
          a 10 10 0 0 1 -10 -10 
          v -40 
          a 10 10 0 0 1 10 -10 
          Z 

          M 50 35 
          a 15 15 0 1 1 0 30 
          a 15 15 0 1 1 0 -30 
          Z

          M 75 28 
          a 4 4 0 1 1 0 0.1 
          Z" style={{fill: "transparent", strokeWidth: "4px", strokeLinecap: "round"}}/>
    </svg>
  );
}
// 